export const ROLES = {
  ADMIN: 'admin',
  GERENTE: 'gerente',
  VENDEDOR: 'vendedor',
  OPERADOR: 'operador',
};

export const getUserRole = (usuario) => usuario?.nivel_acesso;

export const canAccessConfiguracoes = (usuario) => getUserRole(usuario) === ROLES.ADMIN;

export const canAccessRelatorios = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE;
};

export const canAccessVendas = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE || role === ROLES.VENDEDOR;
};

export const canAccessReservas = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE || role === ROLES.VENDEDOR;
};

export const canAccessAvaliacoes = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE || role === ROLES.VENDEDOR;
};

export const canDelete = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE;
};

export const canEditVeiculos = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE || role === ROLES.VENDEDOR;
};

export const canCreateVeiculos = canEditVeiculos;

export const canViewLucros = (usuario) => {
  const role = getUserRole(usuario);
  return role === ROLES.ADMIN || role === ROLES.GERENTE;
};

export const canViewPrecoCompra = canViewLucros;
